import * as React from 'react';
export const IcRoaming = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.69 7.31l-4-4A1 1 0 0015 4v16a1 1 0 002 0V6.45l2.27 2.28a1.003 1.003 0 101.42-1.42zM8 11a.93.93 0 00.45-.11 1 1 0 00.44-1.34l-.73-1.47A3 3 0 006 3H4a1 1 0 00-1 1v6a1 1 0 102 0V9h1c.12.01.24.01.36 0l.75 1.49A1 1 0 008 11zM6 7H5V5h1a1 1 0 010 2zm6-4a1 1 0 00-1 1v13.59l-2.29-2.3a1.005 1.005 0 00-1.714.71c0 .266.106.522.294.71l4 4A1 1 0 0012 21a.84.84 0 00.38-.08A1 1 0 0013 20V4a1 1 0 00-1-1z'
      fill='currentColor'
    />
  </svg>
);
